import React from "react";
import { Modal, Text, Loading } from "@networkraildigitalfactory/components";
import useGeneratePDF from "../../../hooks/adminExport/useGeneratePDF";
import styles from "./AdminExportModal.module.css";
import { getUser } from "../../../services/session";

const AdminExportModal = ({
  show,
  selectedEmployee,
  employeeName,
  contentType,
  year,
  close,
  employeeNumber,
}) => {
  const { email: adminEmail } = getUser();
  const { generatePDF, isGeneratingPDF } = useGeneratePDF(
    { employeeName, contentType, selectedEmployee, year, adminEmail, employeeNumber },
    close
  );

  return (
    <Modal
      type="confirm"
      title="Confirm export"
      id="Confirm export"
      cancelText="Back"
      cancelButtonColor={isGeneratingPDF ? "grey" : "red"}
      confirmText="Export"
      confirmButtonColor={isGeneratingPDF ? "grey" : "blue"}
      show={show}
      onClose={close}
      cancelButtonDisabled={isGeneratingPDF}
      confirmButtonDisabled={isGeneratingPDF}
      onConfirm={generatePDF}
      style={{ maxWidth: "90%", width: "625px", top: "160px", position: "fixed" }}
    >
      <Text wrapper="h1" type="header" style={{ lineHeight: "140%", letterSpacing: "0.0015em" }}>
        Confirm export
      </Text>

      <Loading loading={isGeneratingPDF} />
      <Text wrapper="p" type="body" size="18px">
        By clicking export, you will download the following:
      </Text>
      <Text type="body" wrapper="span" size="18px">
        <span className={styles.boldFont}>Employee name: </span>
        {`${employeeName}`}
      </Text>
      <Text type="body" wrapper="span" size="18px" style={{ margin: "0.1rem 0" }}>
        <span className={styles.boldFont}>Export: </span>
        {`${
          contentType === "pdp"
            ? contentType.toUpperCase()
            : contentType.charAt(0).toUpperCase() + contentType.slice(1)
        } data, ${year}`}
      </Text>
      {isGeneratingPDF && (
        <>
          <Text />
          <Text wrapper="p" type="body" size="18px">
            Please wait while document is being prepared for download
          </Text>
        </>
      )}
    </Modal>
  );
};

export default AdminExportModal;
